jQuery(document).ready(function() {
    jQuery('#series a.toggle-button').click(function(event) {
        event.preventDefault();
        jQuery(jQuery(this).data('origin')).removeClass('active');
        jQuery(jQuery(this).data('target')).addClass('active');
        jQuery(this).addClass('active');
    });

    var showOptionFront = jQuery('.show-options .options .option-front');
    var showOptionBack = jQuery('.show-options .options .option-back');
    var activeSeason = document.querySelector('.swiper-slide-active[data-season]');
    var optionHideSynopsis = jQuery('.show-options').attr('data-option');

    if (activeSeason) {
        ajaxLoadBg(activeSeason.getAttribute('data-season'));
        ajaxLoadEpisodes(activeSeason.getAttribute('data-season'));
        ajaxLoadSeason(activeSeason.getAttribute('data-season'));
    }

    jQuery('.swiper-slide').click(function(event) {
        event.preventDefault();
        jQuery('.swiper-slide-active').removeClass('swiper-slide-active');
        jQuery(this).addClass('swiper-slide-active');
        ajaxLoadBg(jQuery(this).attr('data-season'));
        ajaxLoadEpisodes(jQuery(this).attr('data-season'));
        ajaxLoadSeason(jQuery(this).attr('data-season'));
    });

    function ajaxLoadSeason(seasonId){
        jQuery.ajax({
            url: jQuery('.swiper-slide-active').attr('href') + '/' + seasonId,
            dataType: 'html',
            data: seasonId,
            type: "GET",
            success: function(season) {
                jQuery('.details-block').html(season);
                if (document.querySelector('.details-block .carousel-contributors')) {
                    var mySwiper = new Swiper('.details-block .carousel-contributors', {
                        direction: 'horizontal',
                        loop: false,
                        slidesPerView: 'auto',
                        loopedSlides: null,
                        keyboard: true,
                        mousewheel: {
                            releaseOnEdges: true,
                        },
                        slidesPerColumn: 1,
                        spaceBetween: 10,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                            disabledClass: 'hidden',
                            hiddenClass: 'hidden',
                        },
                    });
                }
                if (document.querySelector('.details-block .carousel-testimonials')) {
                    var mySwiper2 = new Swiper('.details-block .carousel-testimonials', {
                        direction: 'horizontal',
                        loop: false,
                        loopedSlides: null,
                        keyboard: true,
                        mousewheel: {
                            releaseOnEdges: true,
                        },
                        slidesPerColumn: 1,
                        spaceBetween: 10,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0,
                        slidesPerView: 1,
                        breakpoints: {
                            // when window width is >= 468px
                            468: {
                                slidesPerView: 2,
                            },
                            // when window width is >= 992px
                            992: {
                                slidesPerView: 4,
                            }
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                            disabledClass: 'hidden',
                            hiddenClass: 'hidden',
                        },
                    });
                }
                jQuery('.offer-season a').attr('data-season-number', jQuery('.swiper-slide-active').attr('data-season-number'));
                jQuery('.offer-season a').append(jQuery('.swiper-slide-active').attr('data-season-number'));
                jQuery('.gift-season a').append(' <i class="icon-gift"></i>');
            }
        });
    }

    function ajaxLoadBg(seasonId){
        jQuery.ajax({
            url: jQuery('.swiper-slide-active').attr('href') + '/' + seasonId + '/background',
            dataType: 'html',
            data: seasonId,
            type: "GET",
            success: function(url) {
                const $backgroundElem = document.querySelector('.bg-background-profil');
                $backgroundElem.style.backgroundImage = `url('${url}')`;
            }
        });
    }

    function ajaxLoadEpisodes(seasonId){
        jQuery.ajax({
            url: jQuery('.swiper-slide-active').attr('href') + '/' + seasonId + '/episodes',
            dataType: 'html',
            data: seasonId,
            type: "GET",
            success: function(episodes) {
                jQuery('.episodes-wrapper').html(episodes);
                defaultSynopsis();
            }
        });
    }

    jQuery('.show-options .options').click(function(event) {
        event.preventDefault();
        showHideSynopsis();
    });

    jQuery(window).resize(function(event) {
        event.preventDefault();
        if (showOptionFront.css('left') ===  '-70px') {
            if(windowWidth() >= 992){
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'row',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'column',
                    'max-width': '25em',
                    'margin': '0 1em',
                    'border': 'none'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '0',
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'width': '100%',
                    'max-width': '100%',
                });
            } else {
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'column',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'column',
                    'justify-content': 'start',
                    'align-items': 'center',
                    'max-width': '25em',
                    'margin': '0 1em',
                    'paddig': '1em 0',
                    'border-bottom': '1px solid grey'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '0'
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'margin-top': '0',
                    'width': '100%',
                    'max-width': '100%',
                });
            }
        } else {
            if (windowWidth() < 992){
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'column',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'column',
                    'justify-content': 'start',
                    'align-items': 'center',
                    'max-width': '25em',
                    'margin': '0 1em',
                    'paddig': '1em 0',
                    'border-bottom': '1px solid grey'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '0'
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'margin-top': '0',
                    'width': '100%',
                    'max-width': '100%',
                });
            }
            else {
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'column',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'row',
                    'justify-content': 'start',
                    'align-items': 'start',
                    'max-width': '90%',
                    'width': '90%',
                    'margin': '0 1em',
                    'border-bottom': '1px solid grey'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '2em'
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'margin-top': '-1em',
                    'width': '75%',
                    'max-width': '75%',
                });
            }
        }
    });

    function defaultSynopsis(){
        if (optionHideSynopsis == 'hide') {
            jQuery('.show-options .messages .show-message').show();
            jQuery('.show-options .messages .hide-message').hide();
            showOptionBack.css('background-color', 'grey');
            showOptionFront.css('left', '-70px');
            if (windowWidth() >= 992) {
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'row',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'column',
                    'max-width': '25em',
                    'margin': '0 1em',
                    'border': 'none'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '0',
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'width': '100%',
                    'max-width': '100%',
                });
            }
        } else {
            jQuery('.show-options .messages .show-message').hide();
            jQuery('.show-options .messages .hide-message').show();
            showOptionBack.css('background-color', '#FF0064');
            showOptionFront.css('left', '-40px');
            if (windowWidth() >= 992) {
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'column',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'row',
                    'max-width': '90%',
                    'width': '90%',
                    'border-bottom': '1px solid grey'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '2em'
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'margin-top': '-1em',
                    'width': '75%',
                    'max-width': '75%',
                });
            }
        }
    }

    function showHideSynopsis(){
        var toExpire = new Date();
        toExpire.setMonth(toExpire.getMonth() + 1);
        var toUTCstring = toExpire.toUTCString();
        if (showOptionFront.css('left') ===  '-70px') {
            showOptionFront.animate({
                left: '-40px'
            }, "fast");
            jQuery('.show-options .messages .show-message').hide();
            jQuery('.show-options .messages .hide-message').show();
            jQuery('.episode-synopsis').show();
            showOptionBack.css('background-color', '#FF0064');
            if (windowWidth() >= 992) {
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'column',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'row',
                    'max-width': '90%',
                    'width': '90%',
                    'border-bottom': '1px solid grey'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '2em'
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'margin-top': '-1em',
                    'width': '75%',
                    'max-width': '75%',
                });
            }
            showOptionFront.css('left', '-40px');
            optionHideSynopsis = 'show';
            document.cookie = "episodeSynopsis=show; expires=" + toUTCstring + ";";
        } else {
            showOptionFront.animate({
                left: '-70px'
            }, "fast");
            jQuery('.show-options .messages .show-message').show();
            jQuery('.show-options .messages .hide-message').hide();
            jQuery('.episode-synopsis').hide();
            showOptionBack.css('background-color', 'grey');
            if (windowWidth() >= 992) {
                jQuery('.episodes-wrapper').css({
                    'flex-direction': 'row',
                    'justify-content': 'space-evenly',
                    'align-items': 'center',
                });
                jQuery('.episodes-wrapper .episode').css({
                    'flex-direction': 'column',
                    'max-width': '25em',
                    'margin': '0 1em',
                    'border': 'none'
                });
                jQuery('.episodes-wrapper .episode .episode-img').css({
                    'margin-right': '0',
                });
                jQuery('.episodes-wrapper .episode .episode-details').css({
                    'width': '100%',
                    'max-width': '100%',
                });
            }
            showOptionFront.css('left', '-70px');
            optionHideSynopsis = 'hide';
            document.cookie = "episodeSynopsis=hide; expires=" + toUTCstring + ";";
        }
    }

    jQuery('body').on('click', '.series-tvod__close', function(e){
        e.preventDefault();
        jQuery('.series-tvod__container').css("display", "none");
    });

    jQuery('body').on('click','.see-serie-tvod-btn', function(e){
        e.preventDefault();
        ajaxSerieTvodOffer(jQuery(this).attr('data-id'), jQuery(this).attr('data-gift') == 'true');
    });

    function ajaxSerieTvodOffer(filmId, gift) {
        jQuery.ajax({
            url: jQuery('.swiper-slide-active').attr('href') + '/offer' + '/' + filmId + '/' + gift,
            dataType: 'html',
            type: "GET",
            success: function(popUpSerieTvod) {
                jQuery('.offers').html(popUpSerieTvod);
            }
        });
    }

});